import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { tenantContextService } from '../services/api';
import '../styles/Auth.css';

const MIN_QUERY_LENGTH = 3;
const DEBOUNCE_MS = 400;

const TenantDiscoveryPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  const normalizedQuery = useMemo(() => String(query || '').trim(), [query]);

  useEffect(() => {
    let active = true;

    if (normalizedQuery.length < MIN_QUERY_LENGTH) {
      setItems([]);
      setLoading(false);
      setError('');
      return () => {
        active = false;
      };
    }

    const timer = setTimeout(async () => {
      setLoading(true);
      setError('');
      try {
        const response = await tenantContextService.searchTenants(normalizedQuery, 10);
        if (!active) return;
        const payloadItems = Array.isArray(response?.data?.items) ? response.data.items : [];
        setItems(payloadItems);
      } catch (_err) {
        if (!active) return;
        setItems([]);
        setError('Nao foi possivel concluir a busca agora. Tente novamente em instantes.');
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }, DEBOUNCE_MS);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [normalizedQuery]);

  const handleNavigateToSignup = (signupPath) => {
    const safePath = String(signupPath || '').trim();
    if (!safePath.startsWith('/')) {
      return;
    }
    navigate(safePath);
  };

  const showHint = normalizedQuery.length < MIN_QUERY_LENGTH;
  const showEmpty = !loading && !error && normalizedQuery.length >= MIN_QUERY_LENGTH && items.length === 0;

  return (
    <div className="auth-container">
      <div className="auth-card cadastro-card">
        <div className="auth-header">
          <h1>Encontre sua escola ou empresa</h1>
          <p>Digite pelo menos 3 letras do nome ou codigo informado pela escola/empresa.</p>
        </div>

        <form className="auth-form" onSubmit={(event) => event.preventDefault()}>
          <div className="form-group">
            <label htmlFor="tenant-search">Buscar ambiente</label>
            <input
              id="tenant-search"
              type="text"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Ex.: escola alpha"
              autoComplete="off"
            />
          </div>
        </form>

        {showHint ? (
          <div className="alert alert-success">Digite ao menos 3 caracteres para iniciar a busca.</div>
        ) : null}

        {loading ? <div className="alert alert-success">Buscando ambientes...</div> : null}
        {error ? <div className="alert alert-error">{error}</div> : null}
        {showEmpty ? <div className="alert alert-error">Nenhum ambiente encontrado para essa busca.</div> : null}

        {!loading && !error && items.length > 0 ? (
          <div className="auth-form" style={{ gap: 10 }}>
            {items.map((item) => (
              <div
                key={`${item.tenant_slug}-${item.display_name}`}
                style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: 10,
                  padding: 12,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 12,
                }}
              >
                <div style={{ fontWeight: 600 }}>{item.display_name}</div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => handleNavigateToSignup(item.signup_path)}
                >
                  Cadastrar neste ambiente
                </button>
              </div>
            ))}
          </div>
        ) : null}

        <div className="auth-links">
          <Link to="/login" className="link">
            Ja tenho cadastro
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TenantDiscoveryPage;
